import * as RevealContent from '../components/RevealContent';
import { TimelineMax } from 'gsap'

/**
 * INIT
 * ----
 * This function initialize the preloader
 **/
export function init() {
  const tlPreload = new TimelineMax({
    paused: true,
    onComplete: _ => {
      $('.preloader').remove()
      RevealContent.init()
    }
  })

  tlPreload
    .add('start')
    .to('.preloader img', 0.6, {opacity: 0, ease: Power4.easeInOut}, 'start')
    .to('.preloader', 0.6, {opacity: 0, ease: Power4.easeInOut}, 'start+=0.2')

  // first load animation
  if (localStorage.getItem('firstLoad') === null) {
    $('.preloader img').show()
    setTimeout(function() {
      tlPreload.play()
    }, 1000)

    localStorage.setItem('firstLoad', true);
  } else {
    // animation from 2nd load
    TweenLite.to('.preloader', 0.6, {
      opacity: 0,
      ease: Power4.easeInOut,
      onComplete: _ => {
        $('.preloader').remove()
        RevealContent.init()
      }
    })
  }
}


// WEBPACK FOOTER //
// ./scripts/components/Preloader.js